__turbopack_context__.v({
  "category": "Products-module-scss-module__NfCf4G__category",
  "fade-in": "Products-module-scss-module__NfCf4G__fade-in",
  "headingGroup": "Products-module-scss-module__NfCf4G__headingGroup",
  "hero": "Products-module-scss-module__NfCf4G__hero",
  "inner": "Products-module-scss-module__NfCf4G__inner",
  "item": "Products-module-scss-module__NfCf4G__item",
  "productGrid": "Products-module-scss-module__NfCf4G__productGrid",
  "productImage": "Products-module-scss-module__NfCf4G__productImage",
  "productName": "Products-module-scss-module__NfCf4G__productName",
  "root": "Products-module-scss-module__NfCf4G__root",
  "slide": "Products-module-scss-module__NfCf4G__slide",
  "slider": "Products-module-scss-module__NfCf4G__slider",
  "sliderSection": "Products-module-scss-module__NfCf4G__sliderSection",
  "sliderWrapper": "Products-module-scss-module__NfCf4G__sliderWrapper",
  "title": "Products-module-scss-module__NfCf4G__title",
});
